import { createStore, get as idbget, set as idbset, del as idbdel } from 'idb-keyval';
const store = createStore('sakurairo', 'cache');
const get = (key) => idbget(key, store);
const set = (key, value) => idbset(key, value, store);
const del = (key) => idbdel(key, store);
export { get, set, del };
